import cx from 'classnames'
import {Input} from 'components/system/inputs/Input'
import {ReactNode} from 'react'
import {Field, FieldMetaState} from 'react-final-form'
import {ErrorMessage} from './ErrorMessage'
import {Label} from './Label'
import {defaultShowError} from './defaultShowError'

type Props = {
  id?: string
  label?: ReactNode
  name: string
  type: string
  required?: boolean
  placeholder?: string
  className?: string
  validate?: (value: any) => any
  format?: (value: any) => any
  parse?: (value: any) => any
  min?: number
  max?: number
  autoFocus?: boolean
  spellCheck?: boolean
  showError?: (meta: FieldMetaState<unknown>) => string | undefined
}

export const StandardInputField = ({
  id,
  label,
  type,
  name,
  required,
  placeholder,
  className,
  validate,
  format,
  parse,
  min,
  max,
  autoFocus,
  spellCheck,
  showError = defaultShowError,
}: Props) => {
  return (
    <Field
      id={id}
      validate={validate}
      format={format}
      parse={parse}
      name={name}
      type={type}
      render={({input, meta}) => {
        const error = showError(meta)

        return (
          <div className={cx('flex flex-col gap-2', className)}>
            {(label || error) && (
              <div className="flex justify-between">
                {label && (
                  <Label htmlFor={id} required={required}>
                    {label}
                  </Label>
                )}
                {error && <ErrorMessage>{error}</ErrorMessage>}
              </div>
            )}
            <Input
              {...input}
              id={id}
              placeholder={placeholder}
              min={min}
              max={max}
              autoFocus={autoFocus}
              spellCheck={spellCheck}
              className={cx({'!border-brand-red': error})}
            />
          </div>
        )
      }}
    />
  )
}
